const playBlock = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {
        case "E6":
            return `
                <category
                    name="%{BKY_CATEGORY_PLAY}"
                    id="play"
                    colour="#6b7fff"
                    secondaryColour="#3b50e4"
                    showLabelButton="true">
                <block type="play_playSound"/>
                <block type="play_playMP3">
                    <value name="FOLDERNAME">
                        <shadow type="play_folder_menu">
                        </shadow>
                    </value>
                    <value name="MUSICNAME">
                        <shadow type="play_music_menu">
                        </shadow>
                    </value>
                </block>
                <block type="play_pausePlayback"/>
                <block type="play_setMp3Sound"/>
                ${blockSeparator}
                </category>
                `;
        case "C1":
            return `
                <category
                    name="%{BKY_CATEGORY_PLAY}"
                    id="play"
                    colour="#6b7fff"
                    secondaryColour="#3b50e4"
                     showLabelButton="true">
                </category>
                `;
        case "E3":
            return `
                <category
                    name="%{BKY_CATEGORY_PLAY}"
                    id="play"
                    colour="#6b7fff"
                    secondaryColour="#3b50e4"
                    showLabelButton="true">
                <block type="play_playMP3">
                    <value name="FOLDERNAME">
                        <shadow type="play_folder_menu">
                        </shadow>
                    </value>
                    <value name="MUSICNAME">
                        <shadow type="play_music_menu">
                        </shadow>
                    </value>
                </block>
                <block type="play_pausePlayback"/>
                ${blockSeparator}
                </category>
                `;
        case "M6":
            return `
                <category
                    name="%{BKY_CATEGORY_PLAY}"
                    id="play"
                    colour="#6b7fff"
                    secondaryColour="#3b50e4"
                    showLabelButton="true">
                <block type="play_playMP3">
                    <value name="FOLDERNAME">
                        <shadow type="play_folder_menu">
                        </shadow>
                    </value>
                    <value name="MUSICNAME">
                        <shadow type="play_music_menu">
                        </shadow>
                    </value>
                </block>
                <block type="play_pausePlayback"/>
                <block type="play_playSound"/>
                ${blockSeparator}
                </category>
                `;
        case "E7":
            return `
                <category
                    name="%{BKY_CATEGORY_PLAY}"
                    id="play"
                    colour="#6b7fff"
                    secondaryColour="#3b50e4"
                    showLabelButton="true">
                <block type="play_startMp3ByPai">
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_playVoiceByName"/>
                <block type="play_startMp3ByPath">
                    <value name="VALUE">
                        <shadow type="text">
                            <field name="TEXT">music.mp3</field>
                        </shadow>
                    </value>
                </block>
                <block type="play_waitMp3ByPath">
                    <value name="VALUE">
                        <shadow type="text">
                            <field name="TEXT">music.mp3</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_pausePlayback"/>
                <block type="E7_startRecord">
                    <value name="TIME">
                        <shadow type="math_number">
                        <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_playRecord"/>
                <block type="E7_addVoiceSpeed">
                    <value name="VALUE">
                        <shadow type="math_number">
                           <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_setVoiceSpeed">
                    <value name="VALUE">
                        <shadow type="math_number">
                           <field name="NUM">100</field>
                        </shadow>
                    </value>
                </block>
                
                <block type="E7_addVoiceValue">
                    <value name="VALUE">
                        <shadow type="math_number">
                           <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_setVoiceValue">
                    <value name="VALUE">
                        <shadow type="math_number">
                           <field name="NUM">30</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_stopAllVoice"/>
                <block type="E7_getVoiceValue"/>
                <block type="E7_getVoiceSpeed"/>
                ${blockSeparator}
                </category>
                `;
        case "STORM_OS":
            return `
                <category
                    name="%{BKY_CATEGORY_PLAY}"
                    id="play"
                    colour="#6b7fff"
                    secondaryColour="#3b50e4"
                    showLabelButton="true">
                <block type="play_playMP3">
                    <value name="FOLDERNAME">
                        <shadow type="play_folder_menu">
                        </shadow>
                    </value>
                    <value name="MUSICNAME">
                        <shadow type="play_music_menu">
                        </shadow>
                    </value>
                </block>
                <block type="play_pausePlayback"/>
                <block type="play_playSound"/>
                ${blockSeparator}
                </category>
                `;
        default:
            return `
                <category
                    name="%{BKY_CATEGORY_PLAY}"
                    id="play"
                    colour="#6b7fff"
                    secondaryColour="#3b50e4">
                </category>
                `;
    }
}

export default playBlock
